import {createAction, props} from '@ngrx/store';
import {ILocalUser} from '../../models/ILocalUser';
import {IAuthData} from '../../models/IAuthData';
import {ICoordinates} from '../../models/ICoordinates';
import {IUserData} from '../../models/IUserData';
import {User} from 'oidc-client';

export const authorize = createAction('AUTHORIZE', props<{ isAuthorised: boolean, authData: IAuthData }>());
export const setLanguage = createAction('SET_LANGUAGE', props<{ language: string }>());
export const setLocalUser = createAction('SET_LOCAL_USER', props<{localUser: ILocalUser}>());
// TODO: remove any and user user data model
export const getUserData = createAction('GET_USER_DATA', props<{userData: IUserData}>());
export const setUserGeolocation = createAction('setUserGeolocation', props<{userGeolocation: ICoordinates}>());
export const loginAsLocationUser = createAction('LOGGED_IN_AS_LOCATION_USER', props<{ loggedInAsLocationUser: boolean, locationUser: User }>());
